module.exports = __webpack_public_path__ + "img/Cademi-4-en.544b089a.png";